export enum AppInitRequestStatus {
  Pending = 'pending',
  Success = 'success',
  Failed = 'failed',
}

